/*
 * DSD Startup Experience Controller - p11dz181
 * Legacy Retirement Program Phase 1
 *
 * Replaces the legacy fullscreen preloader/click shield with an interaction-first,
 * nonblocking startup lifecycle. This controller never blocks clicks, scroll, autoplay,
 * Wasabi paths, infinite scroll, Firebase, or storefront navigation.
 */
(function(){
  'use strict';
  var VERSION = 'p11dz181-startup-experience-controller-v1';
  if (window.DSDStartupExperienceController && window.DSDStartupExperienceController.version) return;

  var now = function(){ try { return Math.round(performance.now()); } catch(e) { return Date.now(); } };
  var state = {
    version: VERSION,
    owner: 'DSDStartupExperienceController',
    mode: 'interaction-first-no-fullscreen-preloader',
    startedAt: now(),
    visualReadyAt: null,
    contentReadyAt: null,
    interactiveReadyAt: null,
    userReadyAt: null,
    firstScrollAt: null,
    firstPointerAt: null,
    firstClickAt: null,
    retiredLegacyPreloaders: [],
    activeBlockers: [],
    startupOwners: [],
    uxReadinessScore: 0,
    status: 'initializing',
    noTouch: [
      'firebase-reads-disabled',
      'firebase-writes-disabled',
      'firebase-realtime-disabled',
      'comments-reactions-notifications-messaging-stories-universes-galaxies-disabled',
      'autoplay-wasabi-infinite-scroll-preload-unchanged',
      'dawn-visuals-not-disabled',
      'slick-slider-behavior-not-disabled',
      'starfield-not-disabled'
    ]
  };

  function safe(fn, fallback){ try { return fn(); } catch(e) { return fallback; } }
  function arr(x){ return Array.prototype.slice.call(x || []); }
  function visible(el){
    if (!el || !el.getBoundingClientRect) return false;
    var r = el.getBoundingClientRect();
    var cs = getComputedStyle(el);
    return r.width > 0 && r.height > 0 && cs.visibility !== 'hidden' && cs.display !== 'none' && Number(cs.opacity || 1) !== 0;
  }
  function selector(el){
    if (!el) return 'none';
    if (el.id) return el.tagName.toLowerCase() + '#' + el.id;
    var c = (el.className && typeof el.className === 'string') ? el.className.trim().replace(/\s+/g,'.') : '';
    return el.tagName.toLowerCase() + (c ? '.' + c : '');
  }

  function publish(){
    window.DSDInteractionState = {
      version: VERSION,
      visualReady: !!state.visualReadyAt,
      contentReady: !!state.contentReadyAt,
      interactiveReady: !!state.interactiveReadyAt,
      userReady: !!state.userReadyAt,
      visualReadyAt: state.visualReadyAt,
      contentReadyAt: state.contentReadyAt,
      interactiveReadyAt: state.interactiveReadyAt,
      userReadyAt: state.userReadyAt,
      clickReadyTs: state.interactiveReadyAt,
      firstClickAt: state.firstClickAt,
      firstScrollAt: state.firstScrollAt,
      uxReadinessScore: state.uxReadinessScore,
      status: state.status
    };
  }

  function claim(name, owner, meta){
    state.startupOwners.push({ name:name, owner:owner, meta:meta || {}, at:now() });
    safe(function(){ if (window.DSDRegistry && window.DSDRegistry.claim) window.DSDRegistry.claim(name, owner, Object.assign({version:VERSION}, meta || {})); });
  }

  function injectProgress(){
    if (document.getElementById('dsd-startup-progress')) return;
    var style = document.createElement('style');
    style.id = 'dsd-startup-progress-style';
    style.textContent = [
      '#dsd-startup-progress{position:fixed;top:0;left:0;width:100%;height:3px;z-index:2147483000;pointer-events:none;background:transparent;opacity:.95;transition:opacity .22s ease}',
      '#dsd-startup-progress span{display:block;width:22%;height:100%;background:linear-gradient(90deg,#ff3bd5,#7ae7ff,#ffffff);box-shadow:0 0 12px rgba(122,231,255,.85);transform-origin:left center;animation:dsdStartupBar 1.05s ease-out forwards}',
      '#dsd-startup-progress.dsd-done{opacity:0}',
      '@keyframes dsdStartupBar{0%{transform:scaleX(.22)}55%{transform:scaleX(.72)}100%{transform:scaleX(1)}}'
    ].join('');
    var bar = document.createElement('div');
    bar.id = 'dsd-startup-progress';
    bar.setAttribute('aria-hidden','true');
    bar.innerHTML = '<span></span>';
    (document.head || document.documentElement).appendChild(style);
    (document.body || document.documentElement).appendChild(bar);
  }

  function finishProgress(){
    var bar = document.getElementById('dsd-startup-progress');
    if (!bar) return;
    bar.classList.add('dsd-done');
    setTimeout(function(){ if (bar && bar.parentNode) bar.parentNode.removeChild(bar); }, 300);
  }

  function retireLegacyPreloaders(reason){
    var candidates = ['#preloader','.preloader','.dsd-preloader','[data-preloader]','[data-dsd-preloader]'];
    candidates.forEach(function(q){
      arr(document.querySelectorAll(q)).forEach(function(el){
        if (!el || el.__dsdP11dz181Retired) return;
        el.__dsdP11dz181Retired = true;
        state.retiredLegacyPreloaders.push({ selector:q, target:selector(el), reason:reason || 'startup-retirement', at:now() });
        el.classList && el.classList.add('dsd-preloader-hidden','dsd-retired-preloader','dsd-p11dz181-retired');
        el.setAttribute && el.setAttribute('aria-hidden','true');
        el.style.pointerEvents = 'none';
        el.style.visibility = 'hidden';
        el.style.opacity = '0';
        el.style.display = 'none';
        setTimeout(function(){ safe(function(){ if (el && el.parentNode) el.parentNode.removeChild(el); }); }, 60);
      });
    });
    document.documentElement.classList.add('dsd-preloader-complete','dsd-startup-interaction-first','dsd-p11dz181-startup');
    if (document.body) document.body.classList.add('dsd-startup-interaction-first');
  }

  function scanBlockers(){
    var out = [];
    safe(function(){
      var points = [[innerWidth/2, innerHeight/2], [innerWidth/2, Math.min(90, innerHeight-2)], [innerWidth/2, Math.max(2, innerHeight-80)]];
      var main = document.querySelector('main, #MainContent, [role="main"]');
      points.forEach(function(pt){
        var el = document.elementFromPoint(Math.round(pt[0]), Math.round(pt[1]));
        if (!el) return;
        var cs = getComputedStyle(el);
        var r = el.getBoundingClientRect ? el.getBoundingClientRect() : {width:0,height:0};
        var isMain = main && (el === main || main.contains(el));
        var legacy = el.closest && el.closest('#preloader,.preloader,.dsd-preloader,[data-preloader],[data-dsd-preloader]');
        var debug = el.closest && el.closest('.dsd-forensics-panel,#dsd-forensics-panel');
        var covers = r.width >= innerWidth * 0.6 && r.height >= innerHeight * 0.35;
        if (legacy || (!isMain && !debug && cs.pointerEvents !== 'none' && covers && cs.position === 'fixed')) {
          out.push({ at:now(), point:[Math.round(pt[0]),Math.round(pt[1])], target:selector(el), pointerEvents:cs.pointerEvents, position:cs.position, zIndex:cs.zIndex, coversViewport:!!covers, legacyPreloader:!!legacy });
        }
      });
    });
    state.activeBlockers = out.slice(-12);
    return out;
  }

  function computeScore(){
    var ready = state.interactiveReadyAt || now();
    var score = 100;
    if (!state.visualReadyAt) score -= 20;
    if (!state.contentReadyAt) score -= 20;
    if (!state.interactiveReadyAt) score -= 35;
    if (ready > 2000) score -= Math.min(35, Math.round((ready - 2000) / 300));
    if (state.activeBlockers.length) score -= 20;
    state.uxReadinessScore = Math.max(0, Math.min(100, score));
  }

  function markVisual(reason){
    if (!state.visualReadyAt) {
      state.visualReadyAt = now();
      state.status = 'visual-ready';
      document.documentElement.classList.add('dsd-visual-ready');
      claim('startup:visual-ready:p11dz181','DSDStartupExperienceController',{reason:reason});
    }
  }
  function markContent(reason){
    if (!state.contentReadyAt) {
      state.contentReadyAt = now();
      state.status = 'content-ready';
      document.documentElement.classList.add('dsd-content-ready');
      claim('startup:content-ready:p11dz181','DSDStartupExperienceController',{reason:reason});
    }
  }
  function markInteractive(reason){
    if (!state.interactiveReadyAt) {
      retireLegacyPreloaders(reason || 'interactive-ready');
      state.interactiveReadyAt = now();
      state.userReadyAt = state.userReadyAt || state.interactiveReadyAt;
      state.status = 'interactive-ready';
      document.documentElement.classList.add('dsd-interactive-ready','dsd-user-ready');
      finishProgress();
      claim('startup:interactive-ready:p11dz181','DSDStartupExperienceController',{reason:reason, clickReadyMs:state.interactiveReadyAt});
      safe(function(){ document.dispatchEvent(new CustomEvent('dsd:startup:interactive-ready',{detail:{version:VERSION, at:state.interactiveReadyAt, reason:reason}})); });
    }
    computeScore();
    publish();
  }

  function contentLooksReady(){
    var main = document.querySelector('main, #MainContent, [role="main"]');
    var nav = document.querySelector('header a[href], header button, sticky-header a[href], .shopify-section-header a[href]');
    var surfaces = document.querySelector('.shopify-section, .banner, .product, .collection, img, video, a[href], button');
    if (visible(main) || visible(surfaces)) markVisual('visible-surface');
    if ((visible(main) || visible(surfaces)) && nav) markContent('primary-content-navigation-ready');
    return !!((visible(main) || visible(surfaces)) && nav);
  }

  function evaluate(reason){
    retireLegacyPreloaders(reason || 'evaluate');
    if (contentLooksReady()) markInteractive(reason || 'content-ready');
    else {
      var blockers = scanBlockers();
      if (!blockers.length && (document.readyState === 'interactive' || document.readyState === 'complete')) markInteractive(reason || 'dom-ready-no-blockers');
    }
    computeScore();
    publish();
  }

  function bindInputTelemetry(){
    document.addEventListener('pointerdown', function(e){
      if (!state.firstPointerAt) state.firstPointerAt = now();
      if (!state.firstClickAt) state.firstClickAt = state.firstPointerAt;
      publish();
    }, {capture:true, passive:true});
    document.addEventListener('click', function(e){
      if (!state.firstClickAt) state.firstClickAt = now();
      publish();
    }, {capture:true, passive:true});
    window.addEventListener('scroll', function(){
      if (!state.firstScrollAt) state.firstScrollAt = now();
      publish();
    }, {passive:true, once:true});
  }

  function snapshot(reason){
    evaluate(reason || 'snapshot');
    return {
      version: VERSION,
      owner: state.owner,
      mode: state.mode,
      status: state.status,
      uxReadinessScore: state.uxReadinessScore,
      metrics: {
        visualReadyAt: state.visualReadyAt,
        contentReadyAt: state.contentReadyAt,
        interactiveReadyAt: state.interactiveReadyAt,
        userReadyAt: state.userReadyAt,
        firstPointerAt: state.firstPointerAt,
        firstClickAt: state.firstClickAt,
        firstScrollAt: state.firstScrollAt,
        clickReadyMs: state.interactiveReadyAt,
        targetClickReadyMs: 2000
      },
      legacyRetirement: {
        legacyPreloaderRetired: true,
        retiredPreloaders: state.retiredLegacyPreloaders.slice(-20),
        fullscreenStartupOverlay: false,
        startupClickShield: false,
        startupBodyLock: false,
        startupTimerDependency: false
      },
      activeBlockers: scanBlockers(),
      startupOwners: state.startupOwners.slice(-30),
      noTouch: state.noTouch,
      generatedAt: new Date().toISOString(),
      reason: reason || 'snapshot'
    };
  }

  function attachToExports(){
    safe(function(){
      window.DSDRuntimeSnapshotExtenders = window.DSDRuntimeSnapshotExtenders || [];
      window.DSDRuntimeSnapshotExtenders.push(function(s){
        s.startupExperience = snapshot('runtime-snapshot');
        s.uxReadiness = s.startupExperience;
        return s;
      });
    });
    safe(function(){
      window.DSDDashboardSnapshotExtenders = window.DSDDashboardSnapshotExtenders || [];
      window.DSDDashboardSnapshotExtenders.push(function(s){
        s.startupExperience = snapshot('dashboard-snapshot');
        s.uxReadiness = s.startupExperience;
        return s;
      });
    });
  }

  function boot(){
    injectProgress();
    bindInputTelemetry();
    retireLegacyPreloaders('boot');
    evaluate('boot');
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){ evaluate('domcontentloaded'); }, {once:true});
    } else {
      evaluate('document-ready');
    }
    window.addEventListener('load', function(){ evaluate('window-load'); }, {once:true});
    [120, 350, 750, 1200, 1800, 2500].forEach(function(ms){ setTimeout(function(){ evaluate('startup-tick-'+ms); }, ms); });
    attachToExports();
    claim('startup-experience-controller:p11dz181','DSDStartupExperienceController',{mode:state.mode});
    publish();
  }

  window.DSDStartupExperienceController = { version: VERSION, state: state, snapshot: snapshot, evaluate: evaluate, retireLegacyPreloaders: retireLegacyPreloaders };
  boot();
})();
